import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  Toolbar,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Search from "@material-ui/icons/Search";
import Visibility from "@material-ui/icons/Visibility";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { Tooltip } from "recharts";

import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/report/campaign";
import Dialog from "./../../components/Dialog";
import { mapActionsToProps as campaignAction } from "./../../redux/campaigns";
class CampaignReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      openModal: false,
    };
  }

  async componentDidMount() {
    this.history = globalHistory();
    await this.props.getListCampaigns();
  }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaignId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    time: {
                      gte: datetimeHelper.toFormat(
                        this.state.filters.where.gte,
                        "YYYY-MM-DD startDay"
                      ),
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    time: {
                      lte: datetimeHelper.toFormat(
                        this.state.filters.where.lte,
                        "YYYY-MM-DD endDay"
                      ),
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListReportCampaign(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
  }

  handleChange = (name) => {
    return (e) => {
      return this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  handleCampaignDetailReport(item) {
    this.setState({
      openModal: true,
      item: item,
    });
  }

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  render() {
    const { classes, campaignReport, listCampaign } = this.props;
    const { filters, item } = this.state;
    const campaignReportResult =
      typeof campaignReport === "object"
        ? Object.keys(campaignReport).map((key) => campaignReport[key])
        : campaignReport;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const dataReport = [["Chiến dịch", "Nghe máy"]];
    for (const key in campaignReportResult) {
      if (campaignReportResult.hasOwnProperty(key)) {
        const value = campaignReportResult[key];
        dataReport.push([value.campaignName, value.answeredCalls]);
      }
    }
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item xs={12} md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.lte}
                          maxDate={new Date()}
                          minDate={filters.where.gte}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeEnd}
                          name="lte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        {campaignReportResult.length !== 0 ? (
          <Paper
            style={{
              marginTop: 15,
              justifyContent: "center",
              display: "flex",
              backgroundColor: "#fff",
              color: "#000",
              padding: 25,
            }}>
            <Chart
              width={"100%"}
              height={"auto"}
              chartType="BarChart"
              loader={<div>Loading Chart</div>}
              data={dataReport}
              options={{
                title: "Báo cáo chiến dịch telesales",
                isStacked: true,
                hAxis: {
                  title: "Số lượng",
                  minValue: 0,
                },
                vAxis: {
                  title: "Chiến dịch",
                },
                // series: {
                //     1: { curveType: 'function' },
                // },
              }}
              rootProps={{ "data-testid": "3" }}
            />
          </Paper>
        ) : null}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Tên chiến dịch</TableCell>
                <TableCell>Thời gian bắt đầu</TableCell>
                <TableCell>Thời gian kết thúc</TableCell>
                <TableCell>Số danh bạ</TableCell>
                <TableCell>Kết nối</TableCell>
                <TableCell>ACD</TableCell>
                <TableCell>Chi tiết</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {campaignReportResult
                ? campaignReportResult.map((row, key) => {
                    return (
                      <TableRow key={key}>
                        <TableCell component="th" scope="row">
                          {row.campaignName}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {datetimeHelper.toFormat(row.startedAd, "YYYY-MM-DD")}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {datetimeHelper.toFormat(row.endedAt, "YYYY-MM-DD")}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.totalContacts}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.answeredCalls}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Toolbar title="Thời lượng trung bình">
                            {datetimeHelper.secondToHHMMSS(row.acd)}
                          </Toolbar>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Visibility
                            className={classes.icon}
                            onClick={() =>
                              this.history.push(
                                `${process.env.REACT_APP_PATH}/mini-crm/report/campaign-detail/${row.campaignId}`
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Paper>
        <Dialog
          open={this.state.openModal}
          title={item ? item.campaignName : ""}
          onClose={this.handleCloseModal}
          fullwidth={true}
          input={
            <React.Fragment>
              <Paper className={classes.rootDialog}>
                <ValidatorForm
                  ref="form"
                  onSubmit={this.handleSubmit}
                  onError={(errors) => console.log(errors)}
                  className={classes.form}>
                  <Card className={classes.card}>
                    <CardContent>
                      <FormControl className={classes.form}>
                        <FormGroup className={classes.form}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid
                              container
                              spacing={24}
                              style={{ alignItems: "center" }}>
                              <Grid item xs={12} md={3}>
                                <SelectValidator
                                  id="outlined-full-width"
                                  margin="normal"
                                  select
                                  SelectProps={{
                                    MenuProps: {
                                      className: classes.menu,
                                      shrink: true,
                                    },
                                  }}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Lĩnh vực"
                                  variant="outlined"
                                  className={classes.input}
                                  onChange={this.handleSearch}
                                  value={filters.where.campaignId}
                                  name="campaignId"
                                  validators={["required"]}
                                  errorMessages={"Không được để trống"}>
                                  {listCampaignResult
                                    ? listCampaignResult.map((item) => {
                                        return (
                                          <MenuItem
                                            key={item.id}
                                            value={item.id}>
                                            {item.name}
                                          </MenuItem>
                                        );
                                      })
                                    : null}
                                </SelectValidator>
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <InlineDatePicker
                                  margin="normal"
                                  label="Thời gian bắt đầu"
                                  variant="outlined"
                                  className={classes.input}
                                  value={filters.where.gte}
                                  maxDate={new Date()}
                                  format="dd-MM-yyyy"
                                  onChange={this.handleDateChangeStart}
                                  name="gte"
                                />
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <InlineDatePicker
                                  margin="normal"
                                  label="Thời gian kết thúc"
                                  variant="outlined"
                                  className={classes.input}
                                  value={filters.where.lte}
                                  maxDate={new Date()}
                                  minDate={filters.where.gte}
                                  format="dd-MM-yyyy"
                                  onChange={this.handleDateChangeEnd}
                                  name="lte"
                                />
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <Tooltip title="Tìm kiếm" disableFocusListener>
                                  <Fab
                                    color="primary"
                                    aria-label="Search"
                                    className={classes.fab}
                                    onClick={this.handleSubmit}>
                                    <Search />
                                  </Fab>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </FormGroup>
                      </FormControl>
                    </CardContent>
                  </Card>
                </ValidatorForm>
              </Paper>
            </React.Fragment>
          }
        />
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  charts: {
    backgroundColor: "#fff",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
  rootDialog: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
    overflowX: "auto",
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: "#90a4ae",
    },
  },
});

CampaignReport.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  campaignReport: state.reportCampaign.report,
  listCampaign: state.campaign.campaigns,
});
const CampaignAction = connect(null, campaignAction)(CampaignReport);
CampaignReport = connect(mapStateToProps, mapActionsToProps)(CampaignAction);
export default withStyles(styles)(CampaignReport);
